
export default {
  mounted() {
    this.$nextTick(() => {
      // create
      const mm = this.$gsap.matchMedia(this.$refs.container)

      // add a media query. When it matches, the associated function will run
      mm.add('(min-width: 1024px)', () => {
        this.$gsap.set('.icon', {
          opacity: 0,
          yPercent: -100,
        })

        const tl = this.$gsap.timeline({
          scrollTrigger: {
            trigger: this.$refs.container,
            // pin: true,
            start: 'center bottom',
            // end: 'center center',
            // markers: true,
            // scrub: true,
          },
        })
        tl.to('.icon', {
          opacity: 1,
          duration: 0.5,
        })
        tl.to(
          '.icon',
          {
            yPercent: 0,
            duration: 0.8,
            stagger: 0.2,
            ease: 'bounce',
          },
          '>=-.4'
        )
        tl.from(
          '.icon-text',
          {
            opacity: 0,
            duration: 0.3,
            ease: 'easeIn',
          },
          '>=-.2'
        )
      })
    })
  },
}
